import { useTranslation } from 'react-i18next'
import { useState } from 'react'

import { AcknowledgeModal, ConfirmationModal, Modal } from '@percent/lemonade'
import { DeleteCandidateModalProps } from './DeleteCandidateModal.types'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useMutation } from '@percent/utility'

export function DeleteCandidateModal({ isOpen, candidate, refresh, onClose }: Readonly<DeleteCandidateModalProps>) {
  const [modalState, setModalState] = useState<'success' | 'error' | null>(null)

  const { grantProgramService } = useServices()
  const { t } = useTranslation()

  const [{ isPending }, { apiFunc: deleteCandidate }] = useMutation(
    grantProgramService.deleteProgramCandidate,
    () => {
      refresh()
      setModalState('success')
    },
    () => setModalState('error')
  )

  const handleClose = () => {
    onClose()
    setModalState(null)
  }

  const successModal = modalState === 'success' && (
    <AcknowledgeModal
      result="positive"
      title={t('grants.programDetails.candidates.modal.delete.success.title')}
      description={t('grants.programDetails.candidates.modal.delete.success.text', {
        candidateName: candidate?.organisation?.name
      })}
      buttonText={t('button.close')}
      handleClose={handleClose}
      viewTestId="delete-program-candidate-success-modal"
      buttonTestId="close-delete-program-candidate-success-modal"
    />
  )

  const errorModal = modalState === 'error' && (
    <AcknowledgeModal
      result="negative"
      title={t('grants.programDetails.candidates.modal.delete.error.title')}
      description={t('grants.programDetails.candidates.modal.delete.error.description')}
      buttonText={t('button.done')}
      handleClose={handleClose}
      viewTestId="delete-program-candidate-error-modal"
      buttonTestId="close-delete-program-candidate-error-modal"
    />
  )

  return (
    <Modal open={isOpen} onClose={onClose}>
      {successModal || errorModal || (
        <ConfirmationModal
          title={t('grants.programDetails.candidates.actions.delete')}
          loading={isPending}
          primaryButtonText={t('grants.programDetails.candidates.modal.delete.confirm')}
          primaryBtnTestId="delete-program-candidate-modal-button"
          secondaryButtonText={t('button.cancel')}
          handleSubmit={() => deleteCandidate({ candidateId: candidate?.id ?? '' })}
          handleClose={handleClose}
        >
          {t('grants.programDetails.candidates.modal.delete.description', {
            candidateName: candidate?.organisation?.name
          })}
        </ConfirmationModal>
      )}
    </Modal>
  )
}
